/**
 * Normaliza una cadena de texto para facilitar comparaciones:
 * - Convierte a minúsculas.
 * - Elimina acentos y caracteres diacríticos.
 * - Reemplaza múltiples espacios por uno solo.
 * - Elimina espacios al inicio y al final.
 *
 * @param str - Cadena de texto a normalizar.
 * @returns Cadena normalizada.
 */
export const normalize = (str: string): string =>
  str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // quita tildes
    .replace(/\s+/g, ' ') // reemplaza múltiples espacios con uno
    .trim();
